import { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Button, ButtonGroup, Drawer, Typography } from '@mui/material';
import CustomButton from '../../../../../../common/components/buttons/CustomButton';
import CustomTextField from '../../../../../../common/components/customized/customtextfield/CustomTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import PhoneNoTextField from '../../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import CustomSelect from '../../../../../../common/components/customized/customselect/CustomSelect';
import { Country } from 'country-state-city';
import {
  capitalizeFirstLetter,
  debounce,
  useAbort
} from '../../../../../../utils/commonFunctions';
import {
  addAgent,
  agentValidation,
  clearMailError,
  clearUsers,
  getAgent,
  getRateCard,
  setValidationErrors,
  updateAgent
} from '../../../../redux/reducer/autoPlannerSlices/agentslice';
import { Icon } from '@iconify/react';
import './AddAgents.scss';
import { getMyProfileAction } from '../../../../../../common/redux/reducer/commonSlices/myProfileSlice';
function AddAgent({
  setOpen,
  open,
  selected,
  isMapping,
  page,
  roles,
  tabValue,
  clearState,
  setIsScroll,
  setTabValue
}: any) {
  const [role, setRole] = useState(
    roles === 'ROLE_AGENT' ? 'company User' : tabValue === 0 ? 'agent' : 'opertor'
  );
  const addAgentData = useAppSelector(state => state.agentOnboard);
  const updateAgentData = useAppSelector(state => state.autoAgentUpdate);
  const { data } = useAppSelector(state => state.auth);
  const profile = useAppSelector(state => state.myProfile.data);
  const [validationFields, setValidationFields] = useState<any>({
    mail: { status: false },
    userName: { status: false },
    mobileNumber: { status: false }
  });
  const [validationField, setValidationField] = useState('');
  const [validationErrors, setValidationErrorsMake] = useState<any>({
    mail: null,
    userName: null,
    mobileNumber: null
  });
  const mail = useAppSelector(state => state.agentValidation.email);
  const mobile = useAppSelector(state => state.agentValidation.mobileNumber);
  const user = useAppSelector(state => state.agentValidation.userName);
  const rateCardDropDown = useAppSelector(state => state.RateCardGet);
 
  const { company } = useAppSelector(state => state.RoleModuleAccess);
 
  const [error, setError] = useState(false);
 
  const createAbort = useAbort();
 
  let roletype = data?.role;
 
  const APagent = roletype === 'ROLE_AGENT';
 
  const RateCardOption = rateCardDropDown?.data.map((item: any) => ({
    id: item.rateCardId,
    label: capitalizeFirstLetter(item?.rateCardName)
  }));
 
  const isAddingAgent = !selected;
  const validationSchema = (selected: any, validationErrors: any) =>
    yup.object({
      agentname: yup
        .string()
        .required('Enter username')
        .matches(
          /^[a-z0-9]+$/,
          'Username can only contain lowercase letters and numbers without spaces'
        )
        .min(3, 'Username must contain at least 3 characters')
        .max(30, 'Username cannot exceed 30 characters')
        // .matches(/[a-z]/, 'Username must include at least one character')
        .test('agentname', 'Enter valid username', function (value: any) {
          if (
            validationErrors?.userName &&
            validationErrors?.userName !== 'no-error' &&
            value
          ) {
            return this.createError({ message: validationErrors?.userName });
          } else {
            return true;
          }
        }),
      password:
        selected === null
          ? yup
              .string()
              .required('Enter password')
              .min(8, 'Password must be at least 8 characters')
              .max(16, 'Password must not exceed 16 characters')
              .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
              .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
              .matches(/[0-9]/, 'Password must contain at least one number')
              .matches(
                /[@$!%*?&#^()_\-+=]/,
                'Password must contain at least one special character'
              )
          : yup.string().notRequired(),
 
      confirmPassword:
        selected === null
          ? yup
              .string()
              .required('Enter confirm password')
              .max(20, 'Username cannot exceed 20 characters')
              .oneOf([yup.ref('password')], 'Passwords must match')
          : yup.string().notRequired(),
      roletype: yup.string().notRequired(),
 
      companyName: yup.string().when('roletype', {
        is: 'ROLE_AUTOPLANNER_ADMIN',
        then: () =>
          yup
            .string()
            .required('Enter Company name')
            .matches(
              /^[A-Za-z0-9-\s]+$/,
              'Company name must contain letters or numbers only'
            )
            .test(
              'at-least-one-letter',
              'Company name must contain at least one alphabet',
              value => /[A-Za-z]/.test(value || '')
            )
            .min(3, 'Company name must contain at least 3 characters')
            .max(50, 'Company name cannot exceed 50 characters'),
        otherwise: () => yup.string().notRequired()
      }),
      contactperson: yup
        .string()
        .required('Enter contact person name')
        .matches(
          /^[A-Za-z0-9-\s]+$/,
          'contact person name must contain letters or numbers only'
        )
        .test(
          'at-least-one-letter',
          'contact person name must contain at least one alphabet',
          value => /[A-Za-z]/.test(value || '')
        )
        .min(3, 'Contact person name must contain at least 3 characters')
        .max(50, 'Contact person name cannot exceed 50 characters'),
      phone: yup
        .string()
        .required('Enter contact number')
        .min(8, 'Enter valid contact number')
        .test('phone', 'Enter valid contact number', function (value: any) {
          if (
            validationErrors?.mobileNumber &&
            validationErrors.mobileNumber !== 'no-error' &&
            value
          ) {
            return this.createError({ message: validationErrors?.mobileNumber });
          } else {
            return true;
          }
        }),
 
      email: yup
        .string()
        .required('Enter email address')
        .matches(
          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
          'Enter a valid email address'
        )
        .email('Email format is invalid')
        .test('email', 'Enter valid email', function (value: any) {
          if (validationErrors?.mail && validationErrors.mail !== 'no-error' && value) {
            return this.createError({ message: validationErrors?.mail });
          } else {
            return true;
          }
        }),
      ratecard: yup.string().notRequired(),
      country: yup.string().when('roletype', {
        is: 'ROLE_AUTOPLANNER_ADMIN',
        then: () => yup.string().required('Select country'),
        otherwise: () => yup.string().notRequired()
      }),
      website: yup.string().notRequired()
    });
 
  const dispatch = useAppDispatch();
 
  const {
    control,
    handleSubmit,
    setValue,
    trigger,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema(selected, validationErrors))
  });
 
  const removeSpecialCharacters = (phoneNumber: string): string => {
    return phoneNumber.replace(/\D/g, '');
  };

  const onSubmit = async (data: any) => {
    const getPayload = {
      pageNo: page,
      pageSize: 8,
      role: roles.role,
      signal: createAbort().abortCall.signal
    };
    if (!selected) {
      let payload = {
        rateCardId: data.ratecard,
        userCredentialsReq: {
          userName: data.agentname,
          password: data?.password,
          confirmPassword: data?.confirmPassword
        },
        userOnboardProfileReq: {
          companyName: data.companyName,
          country: data.country,
 
          email: data.email,
          contactNumber: `${data.phone}`,
          contactPersonName: data.contactperson,
          timezone: profile?.timezone || 'Asia/Singapore',
          ...(data.website !== '' && { website: data.website })
        },
        roleTypes: [
          role === 'agent'
            ? 'ROLE_AGENT'
            : role === 'operator'
            ? 'ROLE_OPERATOR'
            : 'ROLE_SUB_AGENT'
        ]
      };
      const params = { getPayload, payload };
      const action = await dispatch(addAgent(params));
      if (action.type === addAgent.fulfilled.type) {
        setIsScroll(false);
        clearState();
        dispatch(clearUsers());
        await dispatch(getAgent(getPayload));
        handleClose();
      }
    } else {
      let updatePayload = {
        userID: selected?.id,
        roleTypes: [
          role === 'agent'
            ? 'ROLE_AGENT'
            : role === 'operator'
            ? 'ROLE_OPERATOR'
            : 'ROLE_SUB_AGENT'
        ],
        rateCardId: data.ratecard,
        userOnboardProfileReq: {
          contactNumber: `${data.phone}`,
          country: data.country,
 
          contactPersonName: data.contactperson,
          email: data?.email,
          timezone: profile?.timezone || 'Asia/Singapore',
          ...(data.website !== '' && { website: data.website })
        }
      };
      const param = { getPayload, updatePayload };
      const action = await dispatch(updateAgent(param));
 
      if (action.type === updateAgent.fulfilled.type) {
        setIsScroll(false);
        clearState();
        dispatch(clearUsers());
        await dispatch(getAgent(getPayload));
 
        handleClose();
      }
    }
  };
 
  const handleClose = () => {
    reset();
    setOpen(false);
  };
 
  useEffect(() => {
    if (selected) {
      setValue('companyName', selected.companyName);
      setValue('agentname', selected.userName);
      setValue('ratecard', selected?.rateCardName ? selected?.rateCardId : '');
      setValue('contactperson', selected.contactPersonName);
      setValue('phone', selected.contactNumber);
      setValue('country', selected.country);
      setValue('email', selected.email);
      setValue('website', selected.website);
      setRole(
        selected.roles?.includes('ROLE_OPERATOR')
          ? 'operator'
          : selected.roles?.includes('ROLE_AGENT')
          ? 'agent'
          : 'company User'
      );
    } else {
      reset();
    }
  }, [selected, setValue, reset]);
 
  useEffect(() => {
    if (company) {
      setValue('companyName', company);
    }
  }, [company]);
 
  useEffect(() => {
    if (APagent) setRole('company User');
    if (!APagent) setRole(tabValue === 0 ? 'agent' : 'operator');
    return () => {
      createAbort().abortCall.abort();
    };
  }, []);
 
  // useEffect(() => {
  //   dispatch(getMyProfileAction(createAbort().abortCall.signal));
  //   return () => {
  //     createAbort().abortCall.abort();
  //   };
  // }, []);
  const handleFilterChange = useCallback(
    debounce(async (event: string, field: any) => {
      let eventFilter = field === 'mobileNumber' ? 'mobileNumber' : field;
      setValidationField(field);
 
      dispatch(
        setValidationErrors({ fieldName: field, error: 'no-error', status: false })
      );
      setValidationFields((prev: any) => ({
        ...prev,
        [field]: { status: true }
      }));
      if (['email', 'userName', 'mobileNumber']?.includes(field) && event) {
        const response = await dispatch(
          agentValidation({
            category: eventFilter,
            value: event ? event : null,
            operation: selected ? 'update' : 'add',
            id: selected?.id
          })
        );
 
        if (field === 'mobileNumber' && response?.payload?.status !== 200) setError(true);
        dispatch(
          setValidationErrors({
            fieldName: field,
            error: response?.payload?.status !== 200 ? response.payload : '',
            status: false
          })
        );
        setValidationFields((prev: any) => ({
          ...prev,
          [field]: { status: false }
        }));
        trigger(field);
      }
    }),
    [dispatch]
  );
 
  useEffect(() => {
    setValidationErrorsMake({
      userName: user?.error,
      mobileNumber: mobile?.error,
      mail: mail?.error
    });
  }, [user, mobile, mail]);
 
  useEffect(() => {
    if (validationErrors?.mail) trigger('email');
  }, [validationErrors?.mail]);
 
  useEffect(() => {
    if (validationErrors?.mobileNumber) trigger('phone');
  }, [validationErrors?.mobileNumber, error]);
 
  useEffect(() => {
    if (validationErrors?.userName) trigger('agentname');
  }, [validationErrors?.userName]);
 
  useEffect(() => {
    dispatch(getRateCard());
    setValue('roletype', roletype);
  }, []);
 
  useEffect(() => {
    return () => {
      dispatch(clearMailError());
    };
  }, []);
 
  const formHeader = !APagent
    ? `${selected ? 'Update' : 'Add'} Agent Admin`
    : `${selected ? 'Update' : 'Add'} Agent User`;
 
  return (
    <Box p={2}>
      <Drawer anchor='right' open={open} onClose={handleClose} sx={{ zIndex: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant='h6' sx={{ fontWeight: 700, marginBottom: '10px' }}>
            {isMapping ? 'Driver & Vehicle Mapping' : formHeader}
          </Typography>
          <Box component='form' onSubmit={handleSubmit(onSubmit)}>
            {!APagent && (
              <CustomTextField
                control={control}
                name='companyName'
                placeholder='Company Name'
                id='companyName'
                label='Company Name'
                maxlength={50}
                disabled={isAddingAgent && !company ? false : true}
                defaultValue={selected?.displayName || ''}
              />
            )}
 
            <CustomTextField
              control={control}
              name='contactperson'
              placeholder='Contact person name'
              id='contactperson'
              label='Contact Person Name'
              maxlength={50}
              disabled={isAddingAgent ? false : true}
              defaultValue={selected?.displayName || ''}
            />
            <Controller
              name='phone'
              control={control}
              defaultValue={selected?.mobileNumber || '+65'}
              rules={{ required: true }}
              render={({ field }) => (
                <PhoneNoTextField
                  {...field}
                  setValue={setValue}
                  style='share'
                  country='sg'
                  label='Contact Number'
                  onChange={(e: any) => {
                    if (e) {
                      handleFilterChange(e, 'mobileNumber');
                    }
                    trigger('phone');
                  }}
                  error={Boolean((errors as any)?.phone?.message)}
                  helperText={(errors as any)?.phone?.message}
                />
              )}
            />
            {/* {errors.phone && (
              <Typography
                sx={{
                  color: '#d32f2f',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  fontSize: '12px',
                  marginTop: '-5px',
                  fontWeight: 300,
                  marginBottom: '5px'
                }}
              >
                {errors.phone.message}
              </Typography>
            )} */}
            <CustomTextField
              control={control}
              name='email'
              placeholder='Email address'
              id='email'
              label='Email address'
              maxlength={50}
              defaultValue={selected?.email || ''}
              onChangeCallback={(e: any) => {
                if (e) {
                  handleFilterChange(e, 'email');
                }
                trigger('email');
              }}
            />
            {!APagent && (
              <CustomSelect
                control={control}
                options={RateCardOption}
                isOptional={true}
                name='ratecard'
                placeholder='Rate card'
                id='ratecard'
                label='Rate Card'
              />
            )}
            {!APagent && (
              <>
                <CustomSelect
                  control={control}
                  options={Country.getAllCountries().map((country: any) => ({
                    id: country?.name,
                    label: country?.name,
                    code: country.isoCode
                  }))}
                  name='country'
                  placeholder='Country'
                  id='country'
                  label='Country'
                  defaultValue={selected?.country || ''}
                />
                <CustomTextField
                  control={control}
                  name='website'
                  placeholder='Website URL'
                  id='website'
                  isOptional={true}
                  label='Website URL'
                  maxlength={100}
                  defaultValue={selected?.websiteLink || ''}
                />
              </>
            )}
            <CustomTextField
              control={control}
              name='agentname'
              placeholder='Username'
              id='agentname'
              loading={
                validationFields?.userName?.status && validationField === 'userName'
              }
              label='Username'
              maxlength={30}
              disabled={isAddingAgent ? false : true}
              defaultValue={selected?.name || ''}
              onChangeCallback={(e: any) => {
                if (e) {
                  handleFilterChange(e, 'userName');
                }
                if (e.length > 1) {
                  trigger('agentname');
                }
              }}
            />
            {!selected && (
              <>
                <CustomTextField
                  label='Password'
                  id='password'
                  type='password'
                  placeholder='Password'
                  control={control}
                  name='password'
                  maxlength={16}
                  icon={
                    <Icon
                      icon='teenyicons:lock-outline'
                      width='15'
                      height='15'
                      style={{ color: 'black' }}
                    />
                  }
                />
                <CustomTextField
                  label='Confirm Password'
                  id='confirmPassword'
                  type='password'
                  maxlength={16}
                  placeholder='Confirm Password'
                  control={control}
                  name='confirmPassword'
                  icon={
                    <Icon
                      icon='teenyicons:lock-outline'
                      width='15'
                      height='15'
                      style={{ color: 'black' }}
                    />
                  }
                />
              </>
            )}
 
            <Box
              sx={{
                marginTop: '5%',
                display: 'flex',
                gap: '15px',
                justifyContent: 'end'
              }}
            >
              <CustomButton className='cancel' category='Cancel' onClick={handleClose} />
              <CustomButton
                className='saveChanges'
                type='submit'
                loading={addAgentData?.isLoading || updateAgentData?.isLoading}
                category='Save'
              />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
 
export default AddAgent;